import { useTheme } from '@mui/material'
import IconPlus from './IconPlus'

interface Props extends React.SVGProps<SVGSVGElement> {
  plus?: boolean
  outline?: boolean
  offline?: boolean
  currentColor?: boolean
}

export default function IconAgent({ plus, outline, offline, currentColor, ...props }: Readonly<Props>) {
  const { palette } = useTheme()

  return (
    <svg width="38" height="38" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle
        cx="14"
        cy="14"
        r="12"
        fill={currentColor ? 'currentColor' : offline ? palette.contrast.minimal : palette.node.main}
        stroke={palette.background.default}
        vectorEffect="non-scaling-stroke"
        strokeWidth={outline ? 2 : 0}
      ></circle>
      {plus && <IconPlus color={palette.node.contrastText} />}
    </svg>
  )
}
